import React from 'react';
import { ShowButton, SelectInput, TextInput, DateInput, Filter, DateField, TextField, Datagrid } from 'react-admin';
import TList from '../../components/wrapper/TList';
import { AmountField, LinkField } from '../../components/fields';
import { accountingAccountTransferStatusForSelection } from './AccountingAccountTransferConstants';
import { toApiDateTimeFormat, toJavaScriptDateFormat } from '../../components/helper/DateHelper';
import AccountingAccountTransferListActions from './AccountingAccountTransferListActions';

const AccountingAccountTransferFilter = ({hideAccountIdFilter, ...props}) => (
	<Filter {...props}>
		{!hideAccountIdFilter &&
			<TextInput
				label="resources.accountingAccountTransfers.filter.fromAccountId"
				source="fromAccountId"
				resettable
			/>
		}
		{!hideAccountIdFilter &&
			<TextInput
				label="resources.accountingAccountTransfers.filter.toAccountId"
				source="toAccountId"
				resettable
			/>
		}
		<DateInput
			source="fromDate"
			label="resources.accountingAccountTransfers.filter.fromDate"
			parse={value => toApiDateTimeFormat(value)}
			format={value => toJavaScriptDateFormat(value)}
		/>
		<DateInput
			source="untilDate"
			label="resources.accountingAccountTransfers.filter.untilDate"
			parse={value => toApiDateTimeFormat(value)}
			format={value => toJavaScriptDateFormat(value)}
		/>
		<TextInput
			label="resources.accountingAccountTransfers.filter.ownerType"
			source="ownerType"
			resettable
		/>
		<TextInput
			label="resources.accountingAccountTransfers.filter.ownerId"
			source="ownerId"
			resettable
		/>
		<TextInput
			label="resources.accountingAccountTransfers.filter.transferType"
			source="transferType"
			resettable
		/>
		<SelectInput
			source="transferStatus"
			label="resources.accountingAccountTransfers.filter.transferStatus"
			choices={accountingAccountTransferStatusForSelection}
		/>
		<TextInput
			source="transferQualifier"
			label="resources.accountingAccountTransfers.filter.transferQualifier"
		/>
	</Filter>
);

const AccountingAccountTransferList = ({ hideAccountIdFilter, ...props }) => (
	<TList {...props} sort={{ field: 'id', order: 'DESC' }} actions={<AccountingAccountTransferListActions />} filters={<AccountingAccountTransferFilter hideAccountIdFilter={hideAccountIdFilter} />}>
		<Datagrid>
			<ShowButton />
			<TextField source="id" />
			<LinkField source="fromAccountId" type="Account" />
			<LinkField source="toAccountId" type="Account" />
			<LinkField source="owner" />
			<DateField source="creationDateTime" showTime={true} />
			<TextField source="transferType" />
			<AmountField source="amount" sortable={false} />
			<TextField source="description" sortable={false} />
			<TextField source="transferQualifier" sortable={false} />
			<TextField source="transferStatus" sortable={false} />
		</Datagrid>
	</TList>
);

export default AccountingAccountTransferList;
